import { render, staticRenderFns } from "./AlvVaultModulePanel.vue?vue&type=template&id=d6ff4148"
import script from "./AlvVaultModulePanel.vue?vue&type=script&lang=js"
export * from "./AlvVaultModulePanel.vue?vue&type=script&lang=js"
import style0 from "./AlvVaultModulePanel.vue?vue&type=style&index=0&id=d6ff4148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports